(function (window, document) {
  'use strict';

  var TYPE_IDS = Object.freeze({
    any: ['1', '2', '3', '5', '31', '10', '11'],
    detached: ['1'],
    semi: ['5'],
    townhouse: ['2', '31'],
    condo: ['3'],
    acreage: ['10'],
    land: ['11']
  });

  var TYPE_LABELS = Object.freeze({
    any: 'All residential',
    detached: 'Detached homes',
    semi: 'Semi-detached / duplex homes',
    townhouse: 'Townhomes',
    condo: 'Condos / apartments',
    acreage: 'Acreages',
    land: 'Residential land'
  });

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function parsePrice(value, suffix) {
    var number = parseFloat(String(value || '').replace(/,/g, ''));
    if (!Number.isFinite(number)) return '';
    suffix = String(suffix || '').toLowerCase();
    if (suffix === 'm') number *= 1000000;
    else if (suffix === 'k') number *= 1000;
    else if (number > 0 && number < 10000) number *= 1000;
    return String(Math.round(number));
  }

  function normalizeType(value) {
    var type = String(value || '').toLowerCase().trim();
    if (!type || type === 'all' || type === 'residential' || type === 'any') return 'any';
    if (/semi|duplex|half[-\s]?duplex/.test(type)) return 'semi';
    if (/town|row[-\s]?house/.test(type)) return 'townhouse';
    if (/condo|apartment/.test(type)) return 'condo';
    if (/detached|single[-\s]?family|^house(?:s)?$/.test(type)) return 'detached';
    if (/acreage|rural|country[-\s]?residential/.test(type)) return 'acreage';
    if (/land|lot/.test(type)) return 'land';
    return TYPE_IDS[type] ? type : 'any';
  }

  function parse(rawValue) {
    var raw = clean(rawValue);
    var lower = raw.toLowerCase();
    var intent = {
      raw: raw,
      location: '',
      type: 'any',
      typeLabel: TYPE_LABELS.any,
      beds: '',
      baths: '',
      min: '',
      max: '',
      keywords: '',
      mls: '',
      postal: '',
      blockedIntent: ''
    };

    if (!raw) return intent;

    if (/\b(for\s+rent|rentals?|lease|leasing)\b/i.test(raw)) intent.blockedIntent = 'rent';
    if (/\b(commercial|industrial|office|retail|business\s+for\s+sale)\b/i.test(raw)) intent.blockedIntent = 'commercial';

    var mlsMatch = raw.match(/\b(?:[A-Z]\d{6,9}|\d{7,10})\b/i);
    if (mlsMatch) intent.mls = mlsMatch[0].toUpperCase();

    var postalMatch = raw.match(/\b[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d\b/i);
    if (postalMatch) intent.postal = postalMatch[0].toUpperCase().replace(/\s+/g, ' ').trim();

    if (/\b(semi\s*detached|semi-detached|duplex|half\s*duplex)\b/.test(lower)) {
      intent.type = 'semi';
    } else if (/\b(town\s*home|townhome|townhomes|town\s*house|townhouse|townhouses|row\s*house|rowhouse|row\s*homes?)\b/.test(lower)) {
      intent.type = 'townhouse';
    } else if (/\b(condo|condos|condominium|condominiums|apartment|apartments)\b/.test(lower)) {
      intent.type = 'condo';
    } else if (/\b(detached|single\s*family|single-family|house|houses)\b/.test(lower)) {
      intent.type = 'detached';
    } else if (/\b(acreage|acreages|rural|country\s*residential)\b/.test(lower)) {
      intent.type = 'acreage';
    } else if (/\b(vacant\s*land|residential\s*land|land|lot|lots)\b/.test(lower)) {
      intent.type = 'land';
    }
    intent.typeLabel = TYPE_LABELS[intent.type] || TYPE_LABELS.any;

    var bedsMatch = lower.match(/\b(\d+)\s*(?:\+\s*)?(?:bed|beds|bedroom|bedrooms)\b/);
    if (bedsMatch) intent.beds = bedsMatch[1];
    var bathsMatch = lower.match(/\b(\d+)\s*(?:\+\s*)?(?:bath|baths|bathroom|bathrooms)\b/);
    if (bathsMatch) intent.baths = bathsMatch[1];

    var betweenMatch = lower.match(/\b(?:between|from)\s*\$?\s*([0-9][0-9,.]*)(k|m)?\s*(?:and|to|-)\s*\$?\s*([0-9][0-9,.]*)(k|m)?\b/i);
    var dashMatch = lower.match(/\$?\s*([0-9][0-9,.]*)(k|m)?\s*[-–—]\s*\$?\s*([0-9][0-9,.]*)(k|m)?/i);
    var rangeMatch = betweenMatch || dashMatch;
    if (rangeMatch) {
      intent.min = parsePrice(rangeMatch[1], rangeMatch[2]);
      intent.max = parsePrice(rangeMatch[3], rangeMatch[4]);
      if (Number(intent.min) > Number(intent.max)) {
        var swap = intent.min;
        intent.min = intent.max;
        intent.max = swap;
      }
    } else {
      var maxMatch = lower.match(/\b(?:under|below|up\s*to|max|maximum|less\s*than)\s*\$?\s*([0-9][0-9,.]*)(k|m)?\b/i);
      if (maxMatch) intent.max = parsePrice(maxMatch[1], maxMatch[2]);
      var minMatch = lower.match(/\b(?:over|above|min|minimum|more\s*than|starting\s*at|from)\s*\$?\s*([0-9][0-9,.]*)(k|m)?\b/i);
      if (minMatch) intent.min = parsePrice(minMatch[1], minMatch[2]);
    }

    var keywordMatches = raw.match(/\b(luxury|estate|walkout|garage|triple\s+garage|lakefront|lake|waterfront|view|renovated|new\s+build|newer|bungalow|parking|basement|legal\s+suite|corner\s+lot|ravine|golf\s+course)\b/ig) || [];
    intent.keywords = clean(keywordMatches.join(' '));

    var location = ' ' + raw + ' ';
    location = location.replace(/\b(?:for\s+sale|for\s+rent|rentals?|rents?|lease|leasing|commercial|industrial|office|retail|business|recently\s+sold|sold|mls|listing|listings|property|properties|homes?|houses?|detached|semi\s*detached|semi-detached|duplex|half\s*duplex|single\s*family|single-family|town\s*homes?|townhomes?|town\s*houses?|townhouses?|row\s*houses?|rowhouses?|condos?|condominiums?|apartments?|acreages?|rural|country\s*residential|vacant\s*land|residential\s*land|land|lots?|luxury|open\s*houses?)\b/gi, ' ');
    location = location.replace(/\b\d+\s*(?:\+\s*)?(?:bed|beds|bedroom|bedrooms|bath|baths|bathroom|bathrooms)\b/gi, ' ');
    location = location.replace(/\b(?:between|under|below|up\s*to|max|maximum|less\s*than|over|above|min|minimum|more\s*than|starting\s*at|from)\s*\$?\s*[0-9][0-9,.]*\s*(?:k|m)?(?:\s*(?:and|to|[-–—])\s*\$?\s*[0-9][0-9,.]*\s*(?:k|m)?)?\b/gi, ' ');
    if (intent.mls) location = location.replace(new RegExp('\\b' + intent.mls.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'i'), ' ');
    location = location.replace(/[|]+/g, ' ').replace(/\s*,\s*/g, ', ').replace(/\b(?:in|near|around|at|with|and)\b/gi, ' ').replace(/\s+/g, ' ').trim();
    location = location.replace(/^,|,$/g, '').trim();

    if (intent.mls) intent.location = intent.mls;
    else if (intent.postal && (!location || location.toUpperCase() === intent.postal)) intent.location = intent.postal;
    else intent.location = location || raw;

    return intent;
  }

  function fromParams(paramsLike) {
    var params = paramsLike instanceof URLSearchParams ? paramsLike : new URLSearchParams(paramsLike || window.location.search);
    var raw = params.get('search_text') || params.get('q') || params.get('mls') || '';
    var inferred = parse(raw);
    var intent = {
      raw: raw,
      location: clean(params.get('q') || inferred.location || ''),
      type: normalizeType(params.get('property_type') || params.get('type') || inferred.type),
      typeLabel: '',
      beds: params.get('beds') || inferred.beds || '',
      baths: params.get('baths') || inferred.baths || '',
      min: params.get('min') || inferred.min || '',
      max: params.get('max') || inferred.max || '',
      keywords: clean(params.get('keywords') || inferred.keywords || ''),
      mls: clean(params.get('mls') || params.get('mls_number') || inferred.mls || ''),
      postal: clean(params.get('postal') || inferred.postal || ''),
      blockedIntent: inferred.blockedIntent || ''
    };
    intent.typeLabel = TYPE_LABELS[intent.type] || TYPE_LABELS.any;
    return intent;
  }

  function buildPageUrl(intentLike, origin) {
    var intent = typeof intentLike === 'string' ? parse(intentLike) : intentLike || parse('');
    var url = new URL('/pages/property-search', origin || window.location.origin);
    var locationValue = clean(intent.location || intent.mls || intent.postal || intent.raw || 'Calgary, AB');
    url.searchParams.set('q', locationValue);
    if (intent.raw) url.searchParams.set('search_text', intent.raw);
    url.searchParams.set('province', 'AB');
    url.searchParams.set('market', 'residential');
    url.searchParams.set('residential', '1');
    url.searchParams.set('status', 'sale');
    url.searchParams.set('transaction', 'sale');
    url.searchParams.set('sort', '6-D');
    if (intent.type && intent.type !== 'any') url.searchParams.set('property_type', normalizeType(intent.type));
    if (intent.mls) {
      url.searchParams.set('mls', intent.mls);
      url.searchParams.set('mls_number', intent.mls);
    }
    if (intent.postal) url.searchParams.set('postal', intent.postal);
    if (intent.beds) url.searchParams.set('beds', intent.beds);
    if (intent.baths) url.searchParams.set('baths', intent.baths);
    if (intent.min) url.searchParams.set('min', intent.min);
    if (intent.max) url.searchParams.set('max', intent.max);
    if (intent.keywords) url.searchParams.set('keywords', intent.keywords);
    return url;
  }

  function buildIdxUrl(base, intentLike, options) {
    var intent = typeof intentLike === 'string' ? parse(intentLike) : intentLike || parse('');
    options = options || {};
    var url = new URL(base || 'https://search.jasjeetsingh.ca/index.php', window.location.origin);
    var locationValue = clean(intent.location || intent.mls || intent.postal || intent.raw || 'Calgary, AB').slice(0, 120);
    var type = normalizeType(intent.type);
    var ids = TYPE_IDS[type] || TYPE_IDS.any;

    url.searchParams.set('advanced', '1');
    url.searchParams.set('residential', '1');
    url.searchParams.set('market', 'residential');
    url.searchParams.set('province', 'AB');
    url.searchParams.set('transaction', 'sale');
    url.searchParams.set('status', 'sale');
    url.searchParams.set('display', locationValue);
    url.searchParams.set('area_keyword', locationValue);
    url.searchParams.set('custombox', '');
    ids.forEach(function (id) { url.searchParams.append('types[]', id); });
    url.searchParams.set('beds', intent.beds || '0');
    url.searchParams.set('baths', intent.baths || '0');
    url.searchParams.set('min', intent.min || '0');
    url.searchParams.set('max', intent.max || '100000000');
    url.searchParams.set('sort', options.sort || '6-D');
    url.searchParams.set('rtype', options.view || 'map');

    if (intent.mls) {
      url.searchParams.set('mls', intent.mls);
      url.searchParams.set('mls_number', intent.mls);
    }
    if (intent.postal) url.searchParams.set('postal_code', intent.postal);
    if (intent.keywords) {
      url.searchParams.set('keywords', intent.keywords);
      url.searchParams.set('remarks', intent.keywords);
    }
    if (options.sqft) {
      url.searchParams.set('sqft_min', options.sqft);
      url.searchParams.set('min_sqft', options.sqft);
    }
    if (options.year) {
      url.searchParams.set('yearbuilt', options.year);
      url.searchParams.set('year_built_min', options.year);
    }

    url.hash = 'rslt';
    return url;
  }

  function formatMoney(value, noLimitLabel) {
    var number = parseInt(value, 10) || 0;
    if (!number || number >= 100000000) return noLimitLabel || 'No max';
    if (number >= 1000000) {
      var millions = number / 1000000;
      return '$' + millions.toFixed(number % 1000000 ? 2 : 0).replace(/\.00$/, '') + 'M';
    }
    return '$' + Math.round(number / 1000) + 'K';
  }

  function summary(intent) {
    var parts = [];
    if (intent.location) parts.push(intent.location);
    if (intent.type && intent.type !== 'any') parts.push(TYPE_LABELS[normalizeType(intent.type)]);
    if (intent.beds) parts.push(intent.beds + '+ beds');
    if (intent.baths) parts.push(intent.baths + '+ baths');
    if (intent.min && intent.max) parts.push(formatMoney(intent.min) + '–' + formatMoney(intent.max));
    else if (intent.max) parts.push('under ' + formatMoney(intent.max));
    else if (intent.min) parts.push('over ' + formatMoney(intent.min));
    if (intent.mls) parts.push('MLS® ' + intent.mls);
    return parts.join(' · ') || 'Alberta residential homes';
  }

  function initHomeSearch(form) {
    if (!form || form.dataset.jrSearchReady === 'true') return;
    form.dataset.jrSearchReady = 'true';
    var root = form.closest('.hero-search') || form.parentElement;
    var input = form.querySelector('input[type="search"]');
    var list = root && root.querySelector('.hero-search__suggestions');
    if (!input || !list) return;
    var active = -1;
    var desktopPlaceholder = 'Search by city, community, address or MLS® number';
    var mobilePlaceholder = 'Search by city, community, address or MLS® number';

    function updatePlaceholder() {
      if (input.value) return;
      input.placeholder = window.matchMedia && window.matchMedia('(max-width: 600px)').matches ? mobilePlaceholder : desktopPlaceholder;
    }

    function closeList() {
      list.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-activedescendant', '');
      active = -1;
      window.setTimeout(function () {
        if (!list.classList.contains('is-open')) list.hidden = true;
      }, 170);
    }

    function openList() {
      list.hidden = false;
      window.requestAnimationFrame(function () { list.classList.add('is-open'); });
      input.setAttribute('aria-expanded', 'true');
    }

    function setActive(index) {
      var items = Array.prototype.slice.call(list.querySelectorAll('.hero-search__suggestion'));
      items.forEach(function (item, itemIndex) {
        var selected = itemIndex === index;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      active = index;
      input.setAttribute('aria-activedescendant', items[index] ? items[index].id : '');
    }

    function go(query) {
      var intent = parse(query || input.value);
      var url = buildPageUrl(intent);
      try {
        localStorage.setItem('jrx_last_property_search', JSON.stringify({ intent: intent, view: 'map', sort: '6-D', summary: summary(intent), url: url.href, time: Date.now() }));
      } catch (_) {}
      if (window.jrxTrack) window.jrxTrack('home_property_search', { summary: summary(intent), destination: url.pathname + url.search });
      else if (window.jrxBehavior) window.jrxBehavior('home_property_search', { summary: summary(intent) });
      window.location.assign(url.pathname + url.search);
    }

    function drawSuggestions() {
      var value = clean(input.value);

      // Keep the hero search neutral until the visitor starts typing.
      // Do not show preloaded cities, communities, or example searches on focus.
      if (!value) {
        list.innerHTML = '';
        closeList();
        return;
      }

      var intent = parse(value);
      var suggestions = [
        { type: 'Exact', query: value, title: value, sub: 'Use your exact residential search' },
        { type: intent.type !== 'any' ? 'Property type' : 'Homes', query: value, title: summary(intent), sub: intent.type !== 'any' ? 'Keep the selected property type exact' : 'Residential homes for sale in Alberta' },
        { type: intent.mls ? 'MLS®' : 'Area', query: value, title: intent.mls || intent.location || value, sub: intent.mls ? 'Search this MLS® number' : 'City, community, address, or postal code' }
      ];
      if (intent.blockedIntent) {
        suggestions.unshift({ type: 'For sale only', query: value, title: 'Residential homes for sale', sub: 'Rental and commercial results are excluded' });
      }
      var limit = window.matchMedia && window.matchMedia('(max-width: 600px)').matches ? 3 : 5;
      list.innerHTML = suggestions.slice(0, limit).map(function (item, index) {
        return '<button class="hero-search__suggestion" id="jr-hero-search-option-' + index + '" type="button" role="option" aria-selected="false" data-query="' + escapeHtml(item.query) + '">' +
          '<span class="hero-search__type">' + escapeHtml(item.type) + '</span>' +
          '<span><strong>' + escapeHtml(item.title) + '</strong><small>' + escapeHtml(item.sub) + '</small></span>' +
          '<span class="hero-search__arrow" aria-hidden="true">→</span></button>';
      }).join('');
      setActive(-1);
      openList();
    }

    input.addEventListener('input', drawSuggestions);
    input.addEventListener('focus', drawSuggestions);
    input.addEventListener('keydown', function (event) {
      var items = Array.prototype.slice.call(list.querySelectorAll('.hero-search__suggestion'));
      if (!items.length) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActive((active + 1) % items.length);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive((active <= 0 ? items.length : active) - 1);
      } else if (event.key === 'Enter' && active > -1) {
        event.preventDefault();
        go(items[active].getAttribute('data-query'));
      } else if (event.key === 'Escape') {
        closeList();
      }
    });
    list.addEventListener('pointerdown', function (event) {
      var option = event.target.closest('.hero-search__suggestion');
      if (!option) return;
      // Keep desktop focus stable without cancelling the synthetic touch click.
      if (event.pointerType === 'mouse') event.preventDefault();
    });
    list.addEventListener('click', function (event) {
      var option = event.target.closest('.hero-search__suggestion');
      if (!option) return;
      event.preventDefault();
      go(option.getAttribute('data-query'));
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      go(input.value);
    });
    document.addEventListener('click', function (event) {
      if (root && !root.contains(event.target)) closeList();
    });
    window.addEventListener('resize', updatePlaceholder, { passive: true });
    updatePlaceholder();
  }

  var api = Object.freeze({
    TYPE_IDS: TYPE_IDS,
    TYPE_LABELS: TYPE_LABELS,
    clean: clean,
    escapeHtml: escapeHtml,
    parse: parse,
    fromParams: fromParams,
    normalizeType: normalizeType,
    buildPageUrl: buildPageUrl,
    buildIdxUrl: buildIdxUrl,
    formatMoney: formatMoney,
    summary: summary,
    initHomeSearch: initHomeSearch
  });

  window.JRResidentialSearch = api;

  function boot() {
    document.querySelectorAll('form[data-jr-residential-search]').forEach(initHomeSearch);
    document.dispatchEvent(new CustomEvent('jr:residential-search-ready', { detail: api }));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})(window, document);
